import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
const AuthRoute = (props) => {
    const token = useSelector(state => state?.userData?.access_token)
    const user = useSelector(state => state?.userData?.user)

    const location = useLocation();

    if (!token) {
        return <Navigate to="/" />;
    }

    if (props.name == "application-status") {
        if (user?.approve_status == 'pending') {
            return <Outlet />;
        }
        else if (user?.approve_status == 'approved') {
            return <Navigate to="/dashboard" />;
        }
        else {
            return <Navigate to="/dashboard" />;
        }
    }
    if (props.name == "dashboard") {
        // Commented out approve_status check - redirect directly to dashboard
        // if (user?.approve_status == 'approved') {
        //     return <Outlet />;
        // }
        // else if (user?.approve_status == 'pending') {
        //     return <Navigate to="/application-status" />;
        // }
        // else {
        //     return <Navigate to="/basic-detail" />;
        // }
        return <Outlet />;
    }

    if (props.name == "application_submission") {
        if (user?.approve_status == 'pending') {
            return <Outlet />;
        }
        else if (user?.approve_status == 'approved') {
            return <Navigate to="/dashboard" />;
        }
        else {
            return <Outlet />;
        }
    }


    // if (props.name == "application_submission" && user.is_paid == "1") {
    //     return <Navigate to="/dashboard" />;
    // }
    // ✅ allow access to /application-status even if not approved
    // if (user?.approve_status !== 'approved' && location.pathname !== '/application-status') {
    //     return <Navigate to="/application-status" />;
    // }

    return <Outlet />;

    // return (
    //     <>
    //         {(token && user?.approve_status == 'approved') ? <Outlet /> : <Navigate to='/application-status' />}
    //     </>
    // )
}
export default AuthRoute;